module.exports = __webpack_public_path__ + "img/CUBIC1.f88fed80.png";